import { AnimateProvider } from '@features/animations/components/animate-provider';
import { AnimatedFadeComponent } from '@features/animations/components/animated-fade-component';
import { NAVBAR_ANIMATION_DURATION } from '@features/animations/constants/animations';
import { useListDeleteById } from '@features/lists/hooks/use-list-delete-by-id';
import { useCurrentMatch } from '@features/shared/hooks/use-current-match';
import { useNavigate } from '@features/shared/hooks/use-navigate';
import { toast } from '@features/shared/hooks/use-toast';
import { BottomSheet } from '@features/shared/ui/bottom-sheet';
import { Button } from '@features/shared/ui/button';
import Cog6ToothIcon from '@heroicons/react/24/outline/Cog6ToothIcon';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function RightComponent() {
  const match = useCurrentMatch();

  const { listId = '' } = useParams();
  const [isOpenConfig, setIsOpenConfig] = useState(false);
  const { navigate } = useNavigate();

  const { mutate: deleteListById, isPending } = useListDeleteById({
    onSuccess() {
      setIsOpenConfig(false);

      toast({
        title: 'Sucesso!',
        description: 'Lista apagada com sucesso',
      });

      navigate('/', { replace: true });
    },
  });

  return (
    <>
      <AnimateProvider>
        {match === '/list/:listId' && (
          <AnimatedFadeComponent
            key="cog-config"
            duration={NAVBAR_ANIMATION_DURATION}
          >
            <div
              role="button"
              className="flex items-center justify-end min-w-16 min-h-12"
              onClick={() => setIsOpenConfig(true)}
            >
              <Cog6ToothIcon className="h-6 w-6" />
            </div>
          </AnimatedFadeComponent>
        )}
      </AnimateProvider>

      <BottomSheet
        open={isOpenConfig}
        title="Configurações"
        onClose={() => setIsOpenConfig(false)}
      >
        <div className="py-4">
          <Button
            variant="destructive"
            isLoading={isPending}
            className="w-full"
            onClick={() => {
              deleteListById(listId);
            }}
          >
            Apagar lista
          </Button>
        </div>
      </BottomSheet>
    </>
  );
}
